import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakdownAnalysisResponse } from '../../../maintenance/maintenance-overview/models/maintenance-overview.model';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

// Raw impactOnEfficiency values as returned by the API; the template icon conditions compare against the same strings.
const IMPACT_ON_EFFICIENCY = {
  increased: 'Increased on Efficiency',
  decreased: 'Decreased on Efficiency',
  stable: 'Stable'
} as const;

const IMPACT_LABEL_KEYS: Record<string, string> = {
  [IMPACT_ON_EFFICIENCY.increased]: 'assetShared.breakdownTable.impact.increased',
  [IMPACT_ON_EFFICIENCY.decreased]: 'assetShared.breakdownTable.impact.decreased',
  [IMPACT_ON_EFFICIENCY.stable]: 'assetShared.breakdownTable.impact.stable'
};

@Component({
  selector: 'app-breakdown-analysis-table',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './breakdown-analysis-table.component.html',
  styleUrl: './breakdown-analysis-table.component.scss'
})
export class BreakdownAnalysisTableComponent implements OnInit {
  @Input() data: BreakdownAnalysisResponse[] = [];
  @Input() isLoading: boolean = false;

  private readonly transloco = inject(TranslocoService);

  internalLoading: boolean = true;

  ngOnInit(): void {
    setTimeout(() => {
      this.internalLoading = false;
    }, 1000);
  }

  get showLoading(): boolean {
    return this.isLoading || this.internalLoading;
  }

  getValue(item: any, path: string): any {
    return path.split('.').reduce((obj, key) => obj?.[key], item);
  }

  getImpactLabel(item: BreakdownAnalysisResponse): string {
    const labelKey = IMPACT_LABEL_KEYS[item.impactOnEfficiency];
    return labelKey ? this.transloco.translate(labelKey) : item.impactOnEfficiency;
  }

  getImpactClass(impact: string): string {
    if (impact === IMPACT_ON_EFFICIENCY.increased) {
      return 'impact-positive';
    } else if (impact === IMPACT_ON_EFFICIENCY.stable || impact === 'stable') {
      return 'impact-stable';
    }
    return 'impact-negative';
  }
}